import styled from 'styled-components';

export const StyledOutcomesEdit = styled.div`
  border: 1px solid ${(props) => props.theme.colors.brandThemeLight100}
    ${(props) =>
      props.isBlurred &&
      `
    filter: blur(5px);
    -webkit-filter: blur(5px);
    -moz-filter: blur(5px);
    -ms-filter: blur(5px);
    -o-filter: blur(5px);
    filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='5');
  `};
  ${(props) =>
    props.selected &&
    `
      border-right: 1px solid white;
  `}
`;

export const StyledCloseIconContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 15px;
  cursor: pointer;
`;
